import {createFileRoute, redirect} from "@tanstack/react-router";

// /w/$workspaceId/adgpt/charts → existing AdGPT chat under `_adgptScaffold`.
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold/adgpt/charts/",
)({
    loader: ({params}) => {
        throw redirect({
            to: "/w/$workspaceId/adgpt/chats/$chatId",
            params: {workspaceId: params.workspaceId, chatId: "new"},
        });
    },
});
